import React from "react";
import Logo from "./Logo.js";
import RandomImage from "./RandomImage.js";

function AuthLayout({ children }) {
  return (
    <div className="grid md:grid-cols-2 min-h-screen">
      <div className="hidden md:block">
        <RandomImage />
      </div>
      <div className="flex items-center justify-center p-6 sm:p-8 md:p-12 bg-bg-surface min-h-screen md:min-h-0">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <Logo />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
